<template>
  <create-dialog
    width="80%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
          <fg-input
            type="text"
            :label="`${$t('common_words.code')}: `"
            v-model="model.category_code"
            placeholder="..."
          ></fg-input>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
          <fg-input
            type="text"
            :label="`${$t('common_words.name')}: *`"
            v-model="model.category_name"
            name="common_words.name"
            v-validate="modelValidations.category_name"
            :error="getError('common_words.name', true)"
            placeholder="..."
          >
          </fg-input>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <fg-input
            type="text"
            :label="`${$t('common_words.description')}: `"
            v-model="model.category_description"
            placeholder="..."
          >
          </fg-input>
        </div>
        <div class="col-12">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { isset } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinDialog,
    MixinForm,
    MixinPermissions,
    MixinLoading,
    MixinValidations,
  ],
  data() {
    return {
      disabledField: false,
      businessesInitial: [],
      model: {
        category_name: null,
        category_code: null,
        category_description: null,
        businesses_id: [],
        businesses_names: [],
      },
      modelValidations: {
        category_name: { required: true },
      },
    };
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm') && this.isUpdate()) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const {
        id,
        name: category_name,
        code: category_code,
        description: category_description,
      } = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...this.model,
        id,
        category_name,
        category_code,
        category_description,
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);
      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
